import { z } from 'zod';
import { PriceTypes } from '@/models/catalog/course';

export const externalItemFormSchema = z.object({
  name: z.string({ message: 'Nome obrigatório' }).min(1),
  amount: z.number({ message: 'Valor obrigatório' }).min(0),
  sale_type: z.enum(PriceTypes),
  link: z.url({ message: 'URL inválida' }).optional().nullable(),
  request_reason: z.string().optional().nullable(),
});

export type ExternalItemFormSchema = z.infer<typeof externalItemFormSchema>;
